export default {
  translations: {
    // Mesmo valor usado nas configurações (defaultNS)
    home: {
      message: 'Welcome ',
    },
    login: {
      text: {
        title: 'Login to your account',
        noAccount: "Don't have an account",
      },
      fields: {
        password: 'Password',
        user: 'User',
      },
      helpText: 'Incorrect username or password',
      button: {
        signIn: 'Login',
        signUp: 'Register now',
        forgotPassword: 'Forgot your password',
      },
    },
    register: {
      text: {
        title: 'Register now',
        account: 'Already have an account?',
      },
      fields: {
        password: 'Password',
        fullName: 'Full Name',
        email: 'Email',
      },
      helpText: {
        password: 'Password must be at least 8 characters',
        fullName: 'Full Name must be at least 3 characters',
      },
      button: {
        register: 'Create free account',
        signIn: 'Login',
      },
    },
    order: {
      text: {
        title: 'Orders/Returns',
      },
      buttons: {
        createOrder: 'Create order',
        filter: 'Filter',
        export: 'Export Orders',
      },
      tracking: {
        CREATED: 'Pedido processado',
        CREATE_ORDER_RETURN: 'Criado pedido de retorno',
        FOR_MERCHANT_STORE_IN_BOUND: 'Recebido no Crossdocking',
        FOR_MERCHANT_STORE_IN_STORE: 'Armazenado no e-Box',
        FOR_MERCHANT_STORE_CUSTOMER_TAKEN: 'Retirado pelo usuário',
        FOR_MERCHANT_STORE_COURIER_TAKEN: 'Coletado pelo operador',
        FOR_MERCHANT_STORE_IN_STORE_UPCOMING_EXPIRED:
          'Pedido prestes a expirar',
        FOR_MERCHANT_STORE_IN_STORE_EXPIRED: 'Pedido expirado',
        FOR_MERCHANT_STORE_RETURNED: 'Pedido Retornado ao remetente',
        EXPORTED: 'Successfully exported orders',
      },
      status: {
        null: 'ALL',
        Pendente: 'Pending',
        Aprovado: 'Approved',
        Esperando: 'Waiting',
        Enviado: 'dispatched',
        Recebido: 'Received',
        Resolvido: 'Resolved',
        Rejeitado: 'Rejected',
        CREATED: 'Created',
        IN_BOUND: 'In bound',
        IN_TRANSIT_TO_EBOX: 'In transit',
        STORED: 'Stored',
        CUSTOMER_COLLECTED: 'Collected',
        EXPIRED: 'Expired',
        EXPIRED_COLLECTED: 'Expired/collected',
        EXPIRED_RETURNED: 'Returned',
        Send: 'Send',
        Dispatched: 'Send',
        Pending: 'Pending',
        Received: 'Received',
        Resolved: 'Resolved',
        Rejected: 'Rejected',
        Approved: 'Approved',
        ['Esperando seleção do local de devolução']: 'Esperando local',
      },
    },
    profile: {
      title: 'Profile',
    },
    days: {
      saturday: 'Saturday',
      monday: 'monday',
      tuesday: 'tuesday',
      wednesday: 'wednesday',
      thursday: 'thursday',
      friday: 'friday',
      sunday: 'sunday',
    },
  },
};
